const OverviewUtilizationCard = ({ tileLabel = '', title = '', liner = '', classes = '', btnText = '', btnHandler = () => { } }) => {
  return (
    <div
      className={`flex min-h-[152px] flex-col justify-between rounded-lg border border-gray-200 bg-white p-5 text-left shadow-sm transition-shadow duration-200 hover:shadow-md ${classes}`}
    >
      {tileLabel ? (
        <p className='mb-0 text-[14px] font-medium leading-normal text-gray-600'>{tileLabel}</p>
      ) : null}
      <div
        className={`font-jetbrains-mono text-3xl font-bold tabular-nums leading-none tracking-tight text-gray-900 [&_img]:mr-2 [&_img]:inline-block [&_img]:h-7 [&_img]:w-7 ${tileLabel ? 'mt-2' : ''}`}
      >
        {title}
      </div>
      {liner ? <p className='mb-0 mt-2 text-[12px] font-normal leading-snug text-gray-600'>{liner}</p> : null}
      {btnText ? (
        <button
          type='button'
          className='mb-0 mt-3 inline-flex cursor-pointer border-0 bg-transparent p-0 text-left text-xs font-semibold text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 rounded-sm'
          onClick={btnHandler}
        >
          {btnText}
        </button>
      ) : null}
    </div>
  );
};

export default OverviewUtilizationCard